._1l7dz4w0 {
  min-width: 320px;
  max-width: 480px;
  max-height: 400px;
  overflow-y: auto;
}
._1l7dz4w1 {
  border-radius: var(--pluma-radius-2);
}
._1l7dz4w2 {
  margin-left: var(--pluma-space-050);
}
._1l7dz4w3 {
  cursor: help;
  display: inline-flex;
  align-items: center;
  gap: var(--pluma-space-050);
}
._1l7dz4w4 {
  flex-shrink: 0;
}
._1l7dz4w5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--pluma-space-600);
  gap: var(--pluma-space-200);
}
._1l7dz4w6 {
  text-decoration: underline;
}
._1l7dz4w6:hover {
  text-decoration: none;
}